import { ICouncilCamera } from "dto/Council/ICouncilPortal";

import { decodeText } from "./decodeText";

// Robocza postać konfiguracji kamer w formularzu ustawień. Osobny plik, bo
// CamerasSection eksportuje wyłącznie komponent — inaczej odświeżanie na gorąco
// przestaje działać dla całego modułu.
//
// Hasła nigdy nie przychodzą z serwera: jest tylko flaga HasPassword, a puste pole
// przy zapisie oznacza „bez zmiany". Kasowanie hasła wymaga jawnego RemovePassword.

export interface ICameraPresetDraft {
  Id?: string;
  Name: string;
  Number: string;
}

export interface ICameraDraft {
  /** Puste = kamera jeszcze niezapisana. */
  Id?: string;
  /** Klucz Reacta — Id jest puste dla nowych kamer. */
  Key: string;
  Address: string;
  Login: string;
  /** Wpisywane tylko przy zmianie; puste = bez zmiany. */
  Password: string;
  HasPassword: boolean;
  RemovePassword: boolean;
  Scene: string;
  Presets: ICameraPresetDraft[];
}

export const toCameraDrafts = (cameras: ICouncilCamera[]): ICameraDraft[] =>
  cameras.map((c, index) => ({
    Id: c.Id,
    Key: c.Id ?? `camera-${index}`,
    Address: decodeText(c.Address),
    Login: decodeText(c.Login),
    Password: "",
    HasPassword: c.HasPassword,
    RemovePassword: false,
    Scene: decodeText(c.Scene),
    Presets: c.Presets.map((p) => ({
      Id: p.Id,
      Name: decodeText(p.Name),
      Number: String(p.Number),
    })),
  }));
